import * as $ from "jquery"
import { WindowEx } from "../../window-ex";
import { App } from "../../_app";

//App.Common.Navigation
export class Navigation {
    static init(): void {
        /**
         * Bootstrap Navigation Menu (left side)
         */
        const originalClassesData = "original-classes";
        const navigationMenuButton = $("#navbarLinks");
        navigationMenuButton.on("show.bs.collapse", function () {
            $("body").addClass("full-screen");

            const leftContainer = $("#navbar-left-container");
            leftContainer.data(originalClassesData, leftContainer.attr("class"));
            leftContainer.attr("class", "col-12");

            const rightContainer = $("#navbar-right-container");
            rightContainer.addClass("d-none");

            const menuOpenIcon = $("#hamburger-menu-icon");
            menuOpenIcon.addClass("d-none");
            const menuCloseIcon = $("#hamburger-menu-close-icon");
            menuCloseIcon.removeClass("d-none");
        });
        navigationMenuButton.on("hidden.bs.collapse", function () {
            $("body").removeClass("full-screen");

            const leftContainer = $("#navbar-left-container");
            leftContainer.attr("class", leftContainer.data(originalClassesData));

            const rightContainer = $("#navbar-right-container");
            rightContainer.removeClass("d-none");
        });
        navigationMenuButton.on("hide.bs.collapse", function () {
            // Just clicked on hide, not hidden yet
            const menuOpenIcon = $("#hamburger-menu-icon");
            menuOpenIcon.removeClass("d-none");
            const menuCloseIcon = $("#hamburger-menu-close-icon");
            menuCloseIcon.addClass("d-none");
        });
        $(".navbar-toggler").removeClass("invisible");

        const navigationDropDown = $(".nav-item.dropdown");
        if (navigationDropDown.length) {
            navigationDropDown.on("show.bs.dropdown",
                function (data) {
                    $(data.target).find(".nav-link-plus-container i").removeClass("asf-ui-plus").addClass("asf-ui-close");
                });
            navigationDropDown.on("hide.bs.dropdown",
                function (data) {
                    $(data.target).find(".nav-link-plus-container i").removeClass("asf-ui-close").addClass("asf-ui-plus");
                });
        }

        const contrastLinks = document.getElementsByClassName("change-contrast") as HTMLCollectionOf<HTMLLinkElement>;
        Array.from(contrastLinks).forEach(link => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                App.Common.Functions.changeContrast();
            })
        });

        Navigation.closeOpenedMenu();
        Navigation.addResizeEvent();
    }
    static closeOpenedMenu() {
        if ($("body").hasClass("full-screen")) {
            // Menu is opened
            const breakpoint = App.Common.Functions.getResponsiveBreakpoint();
            if (breakpoint !== "xs" && breakpoint !== "sm" && breakpoint !== "md") {
                $("body").addClass("no-transition");
                $(".navbar-toggler").click();
                $("body").removeClass("no-transition");
            }
        }
    }

    static addResizeEvent() {
        $(window).resize(function () {
            const win = this as WindowEx;
            if (win.resizeTO) window.clearTimeout(win.resizeTO);
            win.resizeTO = window.setTimeout(function () {
                $(this).trigger("resizeEnd");
            }, 200);
        });

        $(window).bind("resizeEnd", function () {
            Navigation.closeOpenedMenu();
        });
    }
}